module.exports = __webpack_public_path__ + "img/results_hw_map.106bf536.png";